module.exports = __webpack_public_path__ + "static/img/1-1.a681cfa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/3/1/1-1.png
// module id = Ia/g
// module chunks = 0